var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationalAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "conversational-ai-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-299, -486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-bot-svgrepo-com",
    transform: "translate(305, 493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,26.7187535 C19.2007192,26.7215186 16.1200463,25.0691096 14.2973437,22.3190156 L16.6401562,20.7617344 C17.9431032,22.7256152 20.1432016,23.906225 22.5,23.906225 C24.8567984,23.906225 27.0568968,22.7256152 28.3598438,20.7617344 L30.7026563,22.3190156 C28.8799537,25.0691096 25.7992808,26.7215186 22.5,26.7187535 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125,11.25 C26.5716991,11.25 25.3125,12.5091991 25.3125,14.0625 C25.3125,15.6158009 26.5716991,16.875 28.125,16.875 C29.6783009,16.875 30.9375,15.6158009 30.9375,14.0625 C30.9448648,13.3143452 30.6509142,12.5946877 30.1218633,12.0656367 C29.5928123,11.5365858 28.8731548,11.2426352 28.125,11.25 L28.125,11.25 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875,11.25 C15.3216991,11.25 14.0625,12.5091991 14.0625,14.0625 C14.0625,15.6158009 15.3216991,16.875 16.875,16.875 C18.4283009,16.875 19.6875,15.6158009 19.6875,14.0625 C19.6948648,13.3143452 19.4009142,12.5946877 18.8718633,12.0656367 C18.3428123,11.5365858 17.6231548,11.2426352 16.875,11.25 L16.875,11.25 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9409688,42.1875 L22.5,40.78125 L28.125,30.9375 L36.5625,30.9375 C37.3088106,30.938772 38.0249202,30.6428643 38.5526423,30.1151423 C39.0803643,29.5874202 39.376272,28.8713106 39.375,28.125 L39.375,8.4375 C39.376272,7.69118941 39.0803643,6.97507975 38.5526423,6.4473577 C38.0249202,5.91963566 37.3088106,5.62372803 36.5625,5.625 L8.4375,5.625 C7.69118941,5.62372803 6.97507975,5.91963566 6.4473577,6.4473577 C5.91963566,6.97507975 5.62372803,7.69118941 5.625,8.4375 L5.625,28.125 C5.62372803,28.8713106 5.91963566,29.5874202 6.4473577,30.1151423 C6.97507975,30.6428643 7.69118941,30.938772 8.4375,30.9375 L21.09375,30.9375 L21.09375,33.75 L8.4375,33.75 C6.9455772,33.7502612 5.5146847,33.1577128 4.45973595,32.102764 C3.40478721,31.0478153 2.81249975,29.6169228 2.81249975,28.125 L2.81249975,8.4375 C2.8120522,6.94552001 3.40454063,5.51451906 4.45952985,4.45952985 C5.51451906,3.40454063 6.94552001,2.8120522 8.4375,2.81249975 L36.5625,2.81249975 C38.05448,2.8120522 39.4854809,3.40454063 40.5404702,4.45952985 C41.5954594,5.51451906 42.1879478,6.94552001 42.1875003,8.4375 L42.1875003,28.125 C42.1875003,29.6169228 41.5952128,31.0478153 40.540264,32.102764 C39.4853153,33.1577128 38.0544228,33.7502612 36.5625,33.75 L29.7627188,33.75 L24.9409688,42.1875 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationalAiIcon);
export default __webpack_public_path__ + "static/media/conversational-ai-icon.105f32873a871f7a5ca369bd058cbb1a.svg";
export { ForwardRef as ReactComponent };